<template>
  <div>
    <div class>
      <div class="five">
        <div class="row">
          <div class="col-md-6">
            <div class="step4-card">
              <div class="row">
                <div class="col-2 svg-wrapper">
                  <svg
                    id="Composant_118_3"
                    data-name="Composant 118 – 3"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="44"
                    height="44"
                    viewBox="0 0 32.285 37.666"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect
                          id="Rectangle_30"
                          data-name="Rectangle 30"
                          width="3.587"
                          height="12.555"
                          fill="#303778"
                        />
                      </clipPath>
                      <clipPath id="clip-path-2">
                        <rect
                          id="Rectangle_29"
                          data-name="Rectangle 29"
                          width="731.797"
                          height="473.516"
                          fill="#303778"
                        />
                      </clipPath>
                      <clipPath id="clip-path-3">
                        <path
                          id="Tracé_56"
                          data-name="Tracé 56"
                          d="M1764.132,620.2h-8.545a3.587,3.587,0,0,1-3.587-3.587V604.055a3.587,3.587,0,0,1,3.587-3.587h8.545l20.153-8.968v37.666ZM1780.7,597.3l-15.719,6.751h-9.392v12.555h9.392l15.719,6.751Z"
                          transform="translate(-1752 -591.5)"
                          fill="#303778"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Groupe_412"
                      data-name="Groupe 412"
                      transform="translate(3.587 12.555)"
                    >
                      <g
                        id="Groupe_55"
                        data-name="Groupe 55"
                        transform="translate(0 0)"
                        clip-path="url(#clip-path)"
                      >
                        <g
                          id="Groupe_54"
                          data-name="Groupe 54"
                          transform="translate(-396.39 -145.283)"
                        >
                          <g
                            id="Groupe_53"
                            data-name="Groupe 53"
                            transform="translate(0 0)"
                            clip-path="url(#clip-path-2)"
                          >
                            <rect
                              id="Rectangle_28"
                              data-name="Rectangle 28"
                              width="12.555"
                              height="21.523"
                              transform="translate(391.906 140.799)"
                              fill="#303778"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g
                      id="Groupe_415"
                      data-name="Groupe 415"
                      clip-path="url(#clip-path-3)"
                    >
                      <g
                        id="Groupe_414"
                        data-name="Groupe 414"
                        transform="translate(-392.803 -132.728)"
                      >
                        <g
                          id="Groupe_413"
                          data-name="Groupe 413"
                          transform="translate(0 0)"
                          clip-path="url(#clip-path-2)"
                        >
                          <rect
                            id="Rectangle_144"
                            data-name="Rectangle 144"
                            width="41.253"
                            height="46.634"
                            transform="translate(388.319 128.244)"
                            fill="#303778"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="col-10">
                  <p>Demande du :</p>
                  <span> {{ formatDate(request.creationDate) }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="step4-card">
              <div class="row">
                <div class="col-2 svg-wrapper">
                  <svg
                    width="44px"
                    height="44px"
                    viewBox="0 0 36 44"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                    <title>Iconspace_Flag</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Antarmuka_One-Color-UI-element-4"
                        transform="translate(-632.000000, -146.000000)"
                      >
                        <g
                          id="Iconspace_Flag"
                          transform="translate(624.000000, 144.000000)"
                        >
                          <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                          <path
                            d="M11.9941606,24 L40.0058394,24 L40.0058394,6 L11.9941606,6 L11.9941606,24 Z M12,28 L12,46 L8,46 L8,2 L44,2 L44,28 L12,28 Z"
                            id="Shape"
                            fill="#303778"
                            fill-rule="nonzero"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="col-10">
                  <p>Demandé d'heures :</p>
                  <span> {{ request.model.totalHours }}</span>
                </div>
              </div>
            </div>
          </div>

          <template v-for="(date, idx) in request.dates">
            <div class="col-md-6" :key="idx">
              <div class="step4-card">
                <div class="row">
                  <div class="col-2 svg-wrapper">
                    <svg
                      width="44px"
                      height="44px"
                      viewBox="0 0 44 44"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                      <title>Iconspace_Calendar</title>
                      <desc>Created with Sketch.</desc>
                      <g
                        id="Page-1"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Antarmuka_One-Color-UI-element-1"
                          transform="translate(-338.000000, -242.000000)"
                        >
                          <g
                            id="Iconspace_Calendar"
                            transform="translate(336.000000, 240.000000)"
                          >
                            <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                            <path
                              d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                              id="Shape"
                              fill="#303778"
                              fill-rule="nonzero"
                            />
                            <polygon
                              id="Shape"
                              fill="#303778"
                              points="10 18 18 18 18 26 10 26"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="col-10">
                    <p>{{ $t("days.off.request.from") }} :</p>
                    <span> {{ formatDate(date.from) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6" :key="idx">
              <div class="step4-card">
                <div class="row">
                  <div class="col-2 svg-wrapper">
                    <svg
                      width="44px"
                      height="44px"
                      viewBox="0 0 44 44"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                      <title>Iconspace_Calendar</title>
                      <desc>Created with Sketch.</desc>
                      <g
                        id="Page-1"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Antarmuka_One-Color-UI-element-1"
                          transform="translate(-338.000000, -242.000000)"
                        >
                          <g
                            id="Iconspace_Calendar"
                            transform="translate(336.000000, 240.000000)"
                          >
                            <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                            <path
                              d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                              id="Shape"
                              fill="#303778"
                              fill-rule="nonzero"
                            />
                            <polygon
                              id="Shape"
                              fill="#303778"
                              points="10 18 18 18 18 26 10 26"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="col-10">
                    <p>{{ $t("days.off.request.to") }} :</p>
                    <span> {{ formatDate(date.to) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="col-md-6" v-if="request.type != 'SIMPLE_ABSENCE'">
            <div class="step4-card">
              <div class="row">
                <div class="col-2 svg-wrapper">
                  <svg
                    width="44px"
                    height="44px"
                    viewBox="0 0 36 44"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                    <title>Iconspace_Flag</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Antarmuka_One-Color-UI-element-4"
                        transform="translate(-632.000000, -146.000000)"
                      >
                        <g
                          id="Iconspace_Flag"
                          transform="translate(624.000000, 144.000000)"
                        >
                          <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                          <path
                            d="M11.9941606,24 L40.0058394,24 L40.0058394,6 L11.9941606,6 L11.9941606,24 Z M12,28 L12,46 L8,46 L8,2 L44,2 L44,28 L12,28 Z"
                            id="Shape"
                            fill="#303778"
                            fill-rule="nonzero"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="col-10">
                  <p>Heure(s) a recuperer :</p>
                  <span> {{ request.model.freeHoursAvailable }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="d-flex justify-content-between pl-3 pr-3 repondre-left-box border-top border-bottom">
            <p class="underline">Demande du :</p>
            <span> {{ formatDate(request.creationDate) }}</span>
          </div>

          <div class="d-flex pl-3 pr-3">
            <p class="text-center">{{ title }}</p>
          </div>

          <template v-for="(date, idx) in request.dates">
            <div class="d-flex justify-content-between pl-3 pr-3 repondre-left-box border-top border-bottom" :key="idx">
              <p class="underline">{{ $t("days.off.request.from") }} :</p>
              <span> {{ formatDate(date.from) }}</span>
            </div>

            <div class="d-flex justify-content-between pl-3 pr-3" :key="idx">
              <p class="underline">{{ $t("days.off.request.to") }} :</p>
              <span> {{ formatDate(date.to) }}</span>
            </div>

          </template>
          <div class="d-flex justify-content-between pl-3 pr-3 repondre-left-box border-top border-bottom">
            <p class="underline">Total d'heures :</p>
            <span> {{ request.model.totalHours }}</span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="mt-4">
      <div class="p-2">
        <div>
          <h6 class="pl-2">Description de la demande :</h6>
          <span class="font-italic">{{ request.model.reason || request.model.comments }}</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import TimeUtils from '../../utils/TimeUtils';

export default {
  name: 'RecapitulatifSimpleAbsence',
  props: {
    request: Object,
    title: String,
  },
  methods: {
    formatDate(date) {
      return TimeUtils.formatDateTime(date);
    },
  },
};
</script>

<style lang="scss">
.repondre-left-box {
  background-color: rgba(0, 0, 0, 0.05);
  color: #000;
  font-size: 16px;
  p {
    font-size: 16px;
  }
}
.step4-card {
  padding: 15px;
  min-height: 70px;
  border-radius: 0;
  border-left: 5px solid #303778;
  margin-bottom: 5px;
  background-color: #f6f8ff;
}
.svg-wrapper svg {
  height: 20px;
}

.step4-card p {
  color: #32356b;
}
.step4-card span {
  color: #6c7899;
}
</style>
